import { useLocale } from "@genius-tracker/i18n/react";

import { ControlNote } from "./views/control/ControlPrimitives.js";

interface GtccCapHintProps {
  readonly limit: number;
  readonly shown: number;
  readonly total?: number | null;
  readonly cursor?: string | null;
  readonly testId?: string;
}

/** Explain a capped first page without claiming that its length is a complete total. */
export function GtccCapHint({ limit, shown, total, cursor, testId }: GtccCapHintProps) {
  const { t } = useLocale();
  if (total !== undefined && total !== null && total <= shown && !cursor) return null;
  if (total == null && !cursor && shown < limit) return null;

  return (
    <ControlNote {...(testId === undefined ? {} : { testId })}>
      {cursor
        ? t("admin.gtcc.cap.more_available", { shown })
        : total !== undefined && total !== null
          ? t("admin.gtcc.cap.shown_of_total", { shown, total })
          : t("admin.gtcc.cap.may_have_more", { shown })}
    </ControlNote>
  );
}
